import { render, staticRenderFns } from "./addUserInfo.vue?vue&type=template&id=0d6fb150&scoped=true"
import script from "./addUserInfo.vue?vue&type=script&lang=js"
export * from "./addUserInfo.vue?vue&type=script&lang=js"
import style0 from "./addUserInfo.vue?vue&type=style&index=0&id=0d6fb150&prod&lang=scss&scoped=true"
import style1 from "./addUserInfo.vue?vue&type=style&index=1&id=0d6fb150&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6fb150",
  null
  
)

export default component.exports